import { render, staticRenderFns } from "./FetchUserEffect.vue?vue&type=template&id=7d85e8e2&"
import script from "./FetchUserEffect.vue?vue&type=script&lang=ts&"
export * from "./FetchUserEffect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports